import './TicketSection.scss';

import { useMemo } from 'react';
import { Outlet } from 'react-router';

import SpinLoading from '@/components/general/SpinLoading';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useInitialLoading } from '@/hooks/useInitialLoading';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';

const TicketSection = () => {
  useDocumentTitle({
    resourceTitle: 'Tickets',
    showTitle: 'Ticket {id}',
    editTitle: 'Ticket {id}',
    createTitle: 'Nuevo ticket',
  });

  const { selectProps: companySelectProps } = useSelectScrollSearch(
    {
      resource: 'empresas',
      optionLabel: (item: any) => item.full_name,
    },
    { saveItem: true },
  );
  const { selectProps: usersSelectProps } = useSelectScrollSearch(
    {
      resource: 'users',
      optionLabel: (item: any) => `${item.first_name} ${item.last_name} (${item.username})`,
      pagination: {
        mode: 'off',
        pageSize: 3000,
      },
      meta: {
        empresa: 4,
      },
    },
    { saveItem: true },
  );
  const { selectProps: subStatusSelectProps } = useSelectScrollSearch({
    resource: 'substatus_ticket',
    optionLabel: (item: any) => item.title,
    pagination: {
      mode: 'off',
      pageSize: 3000,
    },
  });
  const { selectProps: subCategorySelectProps } = useSelectScrollSearch(
    {
      resource: 'subcategoria_ticket',
      optionLabel: (item: any) => item.title_str,
      pagination: {
        mode: 'off',
        pageSize: 3000,
      },
    },
    { saveItem: true },
  );
  const isLoading = useMemo(
    () =>
      companySelectProps.loading ||
      usersSelectProps.loading ||
      subStatusSelectProps.loading ||
      subCategorySelectProps.loading,
    [
      companySelectProps.loading,
      usersSelectProps.loading,
      subStatusSelectProps.loading,
      subCategorySelectProps.loading,
    ],
  );
  const { initialLoading } = useInitialLoading(isLoading);

  return (
    <div className="TicketSection MainSection">
      {initialLoading ? (
        <SpinLoading />
      ) : (
        <Outlet
          context={{
            companySelectProps,
            usersSelectProps,
            subStatusSelectProps,
            subCategorySelectProps,
          }}
        />
      )}
    </div>
  );
};

export default TicketSection;
